//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('../Common')
const ClassFunc = require('../../../util/ClassFunc')

/**
 * The Common class works as the common translator
 * for the org(organization) section.
 */
const tbs_model_to_icehockey_Stats = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_icehockey_Stats.prototype = {
    'platform-title': '北京冰球协会球员统计',
    'player-name-placeholder': '请输入球员姓名',
    'logout': '登出',
    'separator': ' | ',
    'welcome-message': '$name, 欢迎您',
    'footer': '北京冰球协会球员统计 Powered By BMB',
    'rankings': '排行榜',
    'select-gender-placeholder': '全部运动员',
    'select-season-placeholder': '全部赛季',
    'select-group-placeholder': '全部组别',
    'select-stage-type-placeholder': '全部类型',
    'select-position-placeholder': '全部位置',
    'stage-type-1': '常规赛',
    'stage-type-2': '季后赛',
    'position-type-1': '守门员',
    'position-type-2': '后卫',
    'position-type-3': '前锋',
    'skaters': '队员',
    'goalies': '守门员',
    'points': '总得分',
    'goals': '进球数',
    'assists': '助攻数',
    'gaa': '场均失球数',
    'shutouts': '零封次数',
    'wins-percentage': '比赛胜率',
    'more': '更多',
    'skater-rankings': '队员排行榜',
    'skater-report-type-1': '球员概要',
    'skater-report-type-2': '进球类型',
    'skater-report-type-3': '射中对阵',
    'skater-report-type-4': '射门比赛',
    'seq-label': '#',
    'player-name': '球员姓名',
    'group': '组别',
    'position': '位置',
    'games-played': '场次',
    'penalty-mins': '受罚时长',
    'power-play-goals': '多打少进球',
    'short-handed-goals': '少打多进球',
    'overtime-goals': '加时进球',
    'game-winning-goals': '点球制胜',
    'penalty-shot-goals': '罚球进球',
    'empty-net-goals': '空门进球',
    'equal-strength-goals': '人数相等进球',
    'power-play-1-goals': '多一人进球',
    'power-play-2-goals': '多两人进球',
    'short-handed-1-goals': '少一人进球',
    'short-handed-2-goals': '少两人进球',
    'shootout-games-played': '点球场次',
    'shootout-goals': '点球进球',
    'shootout-shots': '点球射门',
    'shootout-shooting-percentage': '点球命中率',
    'i-game-played': '场次，GP（Game Played），参赛场次，指存在检录的比赛中已检录的球员或者未进行检录的比赛中所有球员',
    'i-goals': '进球数，G（Goals），进球数量，指常规比赛时间和加时比赛时间中的进球记录，射门比赛（点球大战）中不做记录',
    'i-assists': '助攻数，A（Assists），助攻数量，指正常进球前，本队最近连续触球的球员，每个进球可以至多计算两位助攻球员',
    'i-points': '总得分，TP（Total Points） / PTS（Points） / P（Points），总得分数量，指进球数加上助攻数',
    'i-penalty-mins': '受罚时长，PIM（Penalty in Minutes），受罚时间总长，指球员在比赛中被判罚时间的总和，以分钟为单位',
    'i-power-play-goals': '优势进球，PPG（Power Play Goals），优势进球数量，指本队在场上比对手多人的情况下的进球记录',
    'i-short-handed-goals': '劣势进球，SHG（Shorthanded Goals），劣势进球数量，指本队在场上比对手少人的情况下的进球记录',
    'i-overtime-goals': '加时进球，OTG（Overtime Goals），加时进球数量，指在加时比赛时间中的进球记录',
    'i-game-winning-goals': '点球制胜，GWG（Game Winning Goals） / GDG（Game Deciding Goals），点球制胜数量，指在比赛中参与射门比赛阶段（点球大战）中射进决胜球的进球记录',
    'i-penalty-shot-goals': '罚球进球，PSG（Penalty Shot Goals），罚球射门进球数量，指在常规比赛时间或加时比赛时间中的罚球射门的进球记录',
    'i-empty-net-goals': '空门进球，ENG（Empty Net Goals），空门进球数量，指在比赛中对方无守门员情况下的进球记录',
    'i-equal-strength-goals': '人数相等进球，EQG（Equal-strength Goals） / EVG（Even-strength Goals），人数相等进球数量，指在比赛中双方场上人数相等情况下的进球记录',
    'i-power-play-1-goals': '多一人进球，PP1G（Power Play +1 Goals），多一人进球数量，指本队在场上比对手多一人的情况下的进球记录',
    'i-power-play-2-goals': '多两人进球，PP2G（Power Play +2 Goals），多两人进球数量，指本队在场上比对手多两人的情况下的进球记录',
    'i-short-handed-1-goals': '少一人进球，SH1G（Shorthanded +1 Goals），少一人进球数量，指本队在场上比对手少一人的情况下的进球记录',
    'i-short-handed-2-goals': '少两人进球，SH2G（Shorthanded +2 Goals），少两人进球数量，指本队在场上比对手少两人的情况下的进球记录',
    'i-shootout-games-played': '点球场次，S/O GP（Shootout Games Played），射门比赛参赛场次，指在比赛中参与到射门比赛阶段（点球大战）且有射门记录的情况',
    'i-shootout-goals': '点球进球，S/O G（Shootout Goals），射门比赛进球数量，指在比赛中参与射门比赛阶段（点球大战）且有射门进球的记录',
    'i-shootout-shots': '点球射门，S/O S（Shootout Shots），射门比赛射门数量，指在比赛中参与射门比赛阶段（点球大战）且有射门记录',
    'i-shootout-shooting-percentage': '点球命中率，S/O S%（Shootout Shooting Percentage），射门比赛进球命中率，指在比赛中参与射门比赛阶段（点球大战）的情况，进球数量除以射门数量的百分数',
    'goalie-rankings': '守门员排行榜',
    'goalie-report-type-1': '球员概要',
    'goalie-report-type-2': '失球类型',
    'goalie-report-type-3': '射失对阵',
    'goalie-report-type-4': '射门比赛',
    'goals-against': '失球',
    'empty-net-goals-against': '空门失球',
    'equal-strength-goals-against': '人数相等失球',
    'power-play-goals-against': '多打少失球',
    'goals-against-average': '场均失球',
    'short-handed-goals-against': '少打多失球',
    'power-play-1-goals-against': '少一人失球',
    'power-play-2-goals-against': '少两人失球',
    'short-handed-1-goals-against': '多一人失球',
    'short-handed-2-goals-against': '多两人失球',
    'overtime-goals-against': '加时失球',
    'game-winning-goals-against': '点球制负',
    'penalty-shot-goals-against': '罚球失球',
    'wins': '胜场数',
    'losses': '负场数',
    'shootout-wins': '点球胜场数',
    'shootout-losses': '点球负场数',
    'shootout-shots-against': '点球射门数',
    'shootout-goals-against': '点球失球数',
    'shootout-saves': '点球救球数',
    'shootout-saves-percentage': '救球成功率',
    'i-goals-against-average': '场均失球，GAA（Goals Against Average），场均失球数，指每场比赛的平均失球数',
    'i-wins': '胜场数，W（Wins），胜场数量，指比赛获胜（不论是常规，加时还是射门比赛）的场次',
    'i-losses': '负场数，L（Losses），负场数量，指比赛落败（不论是常规，加时还是射门比赛）的场次',
    'i-wins-percentage': '比赛胜率，W%（Wins Percentage），比赛获胜比率，指参赛的胜场数除以总参赛场次，保留三位小数',
    'i-shutouts': '零封次数，SO（Shutouts），零封场次数量，指常规比赛时间和加时比赛时间中没有失球的比赛',
    'i-shootout-wins': '点球胜场数，S/O W（Shootouts Wins），射门比赛胜场数量，指比赛通过射门比赛阶段（点球大招）获得胜利结果',
    'i-shootout-losses': '点球负场数，S/O L（Shootouts Losses），射门比赛负场数量，指比赛通过射门比赛阶段（点球大招）获得失败结果',
    'i-shootout-shots-against': '点球射门数，S/O SA（Shootouts Shots Against），射门比赛射门数量，指比赛在射门比赛阶段（点球大战）中射门的次数',
    'i-shootout-goals-against': '点球失球数，S/O GA（Shootouts Goals Against），射门比赛失球数量，指比赛在射门比赛阶段（点球大战）中失球的次数',
    'i-shootout-saves': '点球救球数，S/O Svs（Shootouts Saves），射门比赛救球数量，指比赛在射门比赛阶段（点球大战）中救球的次数',
    'i-shootout-saves-percentage': '救球成功率，S/O Svs%（Shootouts Saves Percentage），射门比赛救球成功率，指比赛在射门比赛阶段（点球大战）中救球次数除以射门次数，保留三位小数',
    'i-goals-against': '失球数，GA（Goals Against），失球数量，指常规比赛时间和加时比赛时间中的失球记录，射门比赛（点球大战）中不做记录',
    'i-power-play-goals-against': '劣势失球，PP GA（Power Play Goals Against），劣势失球数量，指本队在场上比对手少人的情况下的失球记录',
    'i-short-handed-goals-against': '优势失球，SH GA（Shorthanded Goals Against），优势失球数量，指本队在场上比对手多人的情况下的失球记录',
    'i-overtime-goals-against': '加时失球，OT GA（Overtime Goals Against），加时失球数量，指在加时比赛时间中的失球记录',
    'i-game-winning-goals-against': '点球制负，GW GA（Game Winning Goals Against），点球制负数量，指在比赛中参与射门比赛阶段（点球大战）中对方射进决胜球的失球记录',
    'i-penalty-shot-goals-against': '罚球失球，PS GA（Penalty Shot Goals Against），罚球失球数量，指在常规比赛时间或加时比赛时间中的对方罚球射门的失球记录',
    'i-empty-net-goals-against': '空门失球，ENGA（Empty Net Goals Against），空门失球数量，指在比赛中本方无守门员情况下的失球记录',
    'i-equal-strength-goals-against': '人数相等失球，EQGA（Equal-strength Goals Against） / EVG（Even-strength Goals Against），人数相等失球数量，指在比赛中双方场上人数相等情况下的失球记录',
    'i-power-play-1-goals-against': '少一人失球，PP1GA（Power Play +1 Goals Against），少一人失球数量，指本队在场上比对手少一人的情况下的进球记录',
    'i-power-play-2-goals-against': '少两人进球，PP2GA（Power Play +2 Goals Against），少两人失球数量，指本队在场上比对手少两人的情况下的失球记录',
    'i-short-handed-1-goals-against': '多一人失球，SH1GA（Shorthanded +1 Goals Against），多一人失球数量，指本队在场上比对手多一人的情况下的失球记录',
    'i-short-handed-2-goals-against': '多两人失球，SH2GA（Shorthanded +2 Goals Against），多两人失球数量，指本队在场上比对手多两人的情况下的失球记录',
    'birthday': '出生日期',
    'shoots-catches': '持杆方式',
    'height': '身高',
    'weight': '体重',
    'season-period': '经历赛季：$minYear赛季 ~ $maxYear赛季',
    'player-facts': '基本信息',
    'player-stats': '技术统计',
    'player-games': '球员比赛',
    'player-careers': '球员生涯',
    'name': '姓名',
    'gender': '性别',
    'male': '男',
    'female': '女',
    'age': '年龄',
    'nationality': '国籍',
    'birthplace': '所在地',
    'organization': '俱乐部',
    'player-number': '球员号码',
    'school': '学校',
    'grade': '年级',
    'colon': '：',
    'player-selections': '入选信息',
    'level-label': '级别',
    'season-label': '年度',
    'name-label': '名称',
    'level-type-1': '国家队',
    'level-type-2': '北京队',
    'level-type-3': '区队',
    'player-stats-mode-type-1': '总计',
    'player-stats-mode-type-2': '场均',
    'role-type-1': '队员',
    'role-type-2': '守门员',
    'season': '赛季',
    'team': '球队',
    'league': '联盟',
    'select-league-placeholder': '全部联盟',
    'date': '比赛日期',
    'opponent': '对手',
    'score': '比分',
    'dimension-type-1': '赛季',
    'dimension-type-2': '联盟',
    'dimension-type-3': '球队',
    'points-per-games-played': '场均得分',
    'i-points-per-games-played': '场均得分，PGP（Points per Games Played） / PPG（Points Per Game），场均得分数量，指进球数加上助攻数除以场次的平均得分',
    'years': '年数',
    'team-rosters': '球队球员',
    'team-stats': '球队统计',
    'team-games': '球队比赛',
    'team-rankings': '球队排行',
    'num': '号码',
    'category': '分类',
    'height-unit-cm': '身高（CM）',
    'weight-unit-kg': '体重（KG）',
    'all-time-ranking': '全部排行',
    'all-time-points': '总得分排行',
    'all-time-goals': '进球排行',
    'all-time-assists': '助攻排行',
    'all-time-penalty-mins': '受罚时长排行',
    'all-time-games-played': '场次排行',
    'all-time-points-per-game': '场均得分排行',
    'all-time-ranking-per-seaon-league': '赛季联盟排行',
    'league-stats': '联盟统计',
    'league-season-type-1': '单赛季',
    'league-season-type-2': '全部赛季',
    'league-season-type-3': '分赛季',
    'league-season-type-4': '分球队',
    'period': '时段',
    'player-summary': '数据概况',
    'season-total': '参与赛季',
    'match-total': '赛事报名',
    'game-total': '比赛场次',
    'select-player': '选择球员',
    'stats-type-gp': '${games-played}',
    'stats-type-g': '${goals}',
    'stats-type-a': '${assists}',
    'stats-type-p': '${points}',
    'stats-type-pim': '${penalty-mins}',
    'stats-type-gaa': '${gaa}',
    'stats-type-w': '${wins}',
    'stats-type-l': '${losses}',
    'stats-type-wp': '${wins-percentage}',
    'stats-type-so': '${shutouts}',
    'level-rank': '${$level}第$rank',
    'career': '生涯',
    'match': '赛事',
    'data-service-launch': '数据VIP开通查询',
    'launch-service': '开通VIP',
    'player-stats-summary-feature': '查看球员生涯/赛季/联盟/赛事统计排名',
    'player-stats-game-feature': '查看球员全部比赛统计数据',
    'player-stats-group-feature': '查看球员全部赛事组别统计排名',
    'points-i': 'P',
    'goals-i': 'G',
    'assists-i': 'A',
    'penalty-mins-i': 'PIM',
    'power-play-goals-i': 'PPG',
    'short-handed-goals-i': 'SHG',
    'penalty-shot-goals-i': 'PSG',
    'overtime-goals-i': 'OTG',
    'game-winning-goals-i': 'GWG',
    'shootout-shots-i': 'S/O S',
    'shootout-goals-i': 'S/O G',
    'short-date': '日期',
    'goals-against-i': 'GA',
    'power-play-goals-against-i': 'PPGA',
    'short-handed-goals-against-i': 'SHGA',
    'overtime-goals-against-i': 'OTGA',
    'game-winning-goals-against-i': 'GWGA',
    'penalty-shot-goals-against-i': 'PSGA',
    'shootout-shots-against-i': 'S/O SA',
    'shootout-goals-against-i': 'S/O GA',
    'shootout-saves-i': 'S/O Svs',
    'shootout-saves-percentage-i': 'S/O Svs%',
    'games-played-i': 'GP',
    'shootout-games-played-i': 'S/O GP',
    'shootout-shooting-percentage-i': 'S/O S%',
    'goals-against-average-i': 'GAA',
    'wins-i': 'W',
    'losses-i': 'L',
    'wins-percentage-i': 'W%',
    'shutouts-i': 'SO',
    'shootout-wins-i': 'S/O W',
    'shootout-losses-i': 'S/O L',
    'icehockey': '冰球',
    'none-valid-game-stats': '该球员无有效数据服务！',
    'none-valid-detail-page': '该链接无有效数据内容！',
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_icehockey_Stats, Common);

module.exports = tbs_model_to_icehockey_Stats